import { Link } from "react-router-dom";

const ReviewCard = () => {
  const star = <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path  fillRule="evenodd"  clipRule="evenodd"  d="M6.06982 8.89583L5.42174 8.34583C3.11996 6.4 1.60034 5.11667 1.60034 3.54167C1.60034 2.25833 2.68196 1.25 4.05855 1.25C4.83624 1.25 5.58265 1.5875 6.06982 2.12083C6.55699 1.5875 7.30339 1.25 8.08108 1.25C9.45768 1.25 10.5393 2.25833 10.5393 3.54167C10.5393 5.11667 9.01967 6.4 6.71789 8.35L6.06982 8.89583Z"  fill="#25BCA7" /></svg>
  const starDisabled = <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" clipRule="evenodd" d="M5.94189 8.89583L5.29382 8.34583C2.99203 6.4 1.47241 5.11667 1.47241 3.54167C1.47241 2.25833 2.55403 1.25 3.93062 1.25C4.70831 1.25 5.45472 1.5875 5.94189 2.12083C6.42906 1.5875 7.17547 1.25 7.95315 1.25C9.32975 1.25 10.4114 2.25833 10.4114 3.54167C10.4114 5.11667 8.89174 6.4 6.58996 8.35L5.94189 8.89583Z" fill="#03DAC5" fillOpacity="0.27"/></svg>
  return (
    <div className="slide_inner">
      <div className="review_card py-3">
        <div className="container-fluid">
          <div className="row">
            <div className={`col-4 col-lg-4 col-md-4 col-sm-4 ${window.innerWidth > 350 ? "pl-4" : "pl-5"}`}>
              <img
                src="https://www.docterio.com/static/profile_pics/acaf484db6c7bdd3.png"
                className="w-100"
                alt=""
              />
            </div>
            <div className="col-8 pl-0">
              <p style={{ fontSize:  window.innerWidth > 576 ? `1.1rem` : "1.8rem"  }} className="mb-1">
                <b>Andrew Fallis</b>
              </p>
              <p style={{ fontSize: window.innerWidth > 576 ? `0.9rem` : "1.3rem" }} className="mb-0">
                Prime Care Doctor
              </p>
              <p style={{ fontSize:  window.innerWidth > 576 ? `0.75rem` : "1.1rem" , color: `#666` }} className="mb-0">
                New York
              </p>
            </div>
          </div>
        </div>
        <div className="content pl-4">
          <p className=" mb-0 py-4" style={{ fontSize:  window.innerWidth > 576 ? `0.8rem` : "1.2rem"  }}>
            "The best and mostly tharough Dr."
          </p>
          <p style={{ fontSize:  window.innerWidth > 576 ? `0.8rem` : "1.2rem"  }}>
            {star}
            {star}
            {star}
            {star}
            {starDisabled}
            <b>&nbsp; 100 Reviews</b>
          </p>
          <p>
            <Link className="check text-uppercase" to="/">
              Check Availability
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ReviewCard;
